import { Link } from "react-router-dom";
import { usePageSeo } from "../lib/seo";

export const PrivateBeta = () => {
  usePageSeo({
    title: "Urban by VeerGi — Private Beta",
    description: "A new Urban experience is coming soon.",
    robots: "noindex,nofollow",
  });

  return (
    <main
      data-testid="private-beta-page"
      className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
      style={{ backgroundColor: "#0C0A07" }}
    >
      <img
        src="/logo-emblem.png"
        alt="Urban by VeerGi"
        className="w-24 h-24 md:w-28 md:h-28 object-contain mb-8"
        data-testid="private-beta-logo"
      />
      <p className="tracking-[0.35em] uppercase text-xs md:text-sm mb-4" style={{ color: "#C9A227" }}>
        Private Beta
      </p>
      <h1
        data-testid="private-beta-headline"
        className="text-4xl sm:text-5xl lg:text-6xl font-serif text-white max-w-2xl leading-tight"
      >
        A new Urban experience is coming soon.
      </h1>
      <div className="mt-10 h-px w-24" style={{ backgroundColor: "#C9A22755" }} />
      <p className="mt-8 text-sm md:text-base text-white/60 max-w-md">
        Hungry now? Our Urban Turban kitchen on Halsted is open and taking orders today.
      </p>
      <a
        href="https://tryurbanturban.com"
        data-testid="private-beta-order-cta"
        className="mt-6 inline-flex items-center gap-2 rounded-full px-8 py-3.5 text-sm font-semibold tracking-wide transition-transform duration-200 hover:scale-[1.03]"
        style={{ backgroundColor: "#C9A227", color: "#0C0A07" }}
      >
        Order from Urban Turban
      </a>
      <Link
        to="/beta-access"
        data-testid="private-beta-team-access-link"
        className="mt-14 text-xs text-white/30 hover:text-white/60 transition-colors duration-200 underline underline-offset-4"
      >
        Team access
      </Link>
    </main>
  );
};
